// Deeplink Landing Page — backend API client
import axios from "axios";
import { getDeeplinkApiBase } from "./utils";

const client = axios.create({
  timeout: 8000,
  headers: { "Content-Type": "application/json" },
});

/**
 * GET /deeplink/v1/resolve — Section 4.1
 * Resolves the universal link and returns routing instructions.
 *
 * @param {Object} params
 * @param {string} params.destination  Required — target destination
 * @param {string} params.platform     Required — ios | android | desktop
 * @param {boolean} [params.app_installed]
 * @param {string} [params.user_state] logged_in | not_logged_in | no_account
 * @param {string} [params.lang]       Currently 'th' only
 * @param {string} [params.ref_id]     Tracking reference
 */
export const resolveDeeplink = async ({
  destination,
  platform,
  app_installed,
  user_state,
  lang,
  ref_id,
}) => {
  const params = { destination, platform };
  if (app_installed !== undefined) params.app_installed = app_installed;
  if (user_state) params.user_state = user_state;
  if (lang) params.lang = lang;
  if (ref_id) params.ref_id = ref_id;

  const res = await client.get(`${getDeeplinkApiBase()}/resolve`, { params });
  return res.data;
};

/**
 * POST /deeplink/v1/tracking/event — Section 4.4
 * Server-side tracking fallback. The mobile app fires events via the Firebase
 * SDK directly; this is used by the web landing page where the JS SDK may not
 * be loaded.
 */
export const trackEvent = async ({
  event_name,
  destination,
  platform,
  user_state,
  ref_id,
}) => {
  try {
    await client.post(`${getDeeplinkApiBase()}/tracking/event`, {
      event_name,
      destination,
      platform,
      user_state,
      ref_id,
      timestamp: new Date().toISOString(),
    });
  } catch (err) {
    // Tracking failures must never block the user journey.
    // eslint-disable-next-line no-console
    console.warn("[deeplink] tracking event failed:", event_name, err?.message);
  }
};
